import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { DEFAULT_PROMPT } from '../constants/promptMessages';
import MarkdownText from './MarkdownText';
import { resetPromptMessage } from '../actions/prompt';
import { TRANSLATION_FILES } from '../constants/translation';

class ChangesPrompt extends Component {
  static propTypes = {
    prompt: PropTypes.shape({
      callback: PropTypes.func,
      header: PropTypes.node,
      icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
      ]),
      samePage: PropTypes.bool,
      message: PropTypes.node,
      show: PropTypes.bool,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const { prompt } = nextProps;
    if (prompt) {
      this.setState({
        show: prompt.show,
      });
    }
  }
  componentWillUpdate() {
    this.fixBody();
  }
  componentDidUpdate() {
    this.fixBody();
  }
  fixBody = () => {
    const anotherModal = document.getElementsByClassName('ui page modals');
    if (anotherModal.length > 0) {
      // fix for modal prompt over existing modal
      document.body.classList.add('dimmable', 'dimmed');
    }
  }
  handleOnCancel = () => {
    this.close();
  }
  close(callback) {
    this.setState({
      show: false,
    }, () => {
      if (callback) {
        callback();
      }
      this.handleResetPrompt();
    });
  }
  handleOnComfirm = () => {
    this.close(() => {
      const { prompt } = this.props;
      if (prompt && prompt.callback) {
        prompt.callback();
      }
    });
  }
  handleResetPrompt = () => {
    const { store } = this.context;
    store.dispatch(resetPromptMessage());
  }
  render() {
    const { prompt, t } = this.props;
    return (
      <Modal
        size="small"
        open={this.state.show}
        onClose={this.handleOnCancel}
      >
        <Header icon={prompt.icon} content={t(prompt.header)} />
        <Modal.Content>
          <Modal.Description>
            <MarkdownText>
              {t(prompt.message || DEFAULT_PROMPT)}
            </MarkdownText>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.handleOnCancel} content={t(prompt.samePage ? 'Keep Editing' : 'Stay')} />
          <Button color="blue" onClick={this.handleOnComfirm} content={t(prompt.samePage ? 'Cancel' : 'Leave')} />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  prompt: state.prompt,
});

export default withTranslation(TRANSLATION_FILES.translation)(
  connect(mapStateToProps)(ChangesPrompt),
);



// WEBPACK FOOTER //
// ./src/components/ChangesPrompt.jsx